export const formatFile = (key, fileArr) => {
  const originalFile = fileArr[0]
  const fileExtension = originalFile.type.split('/')[1]

  const newFileName = `${key}.${fileExtension}`
  const newFile = new File([originalFile], newFileName, { type: originalFile.type })
  return newFile
}
